<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div>
          <label class="label-input">Review Grid</label>
          <ckeditor :editor="editor" v-model="fields['title-review']" :config="editorConfig" />
        </div>
        <v-row class="mt-4">
          <v-col cols="12">
            <div style="margin-bottom: 20px">
              <div>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="background"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['background-color']"
                    @change="handleChangeBackgroundColor"
                  />
                  <v-text-field v-model="fields['background-color']" label="Background Color" />
                  <v-btn @click="handleResetBackgroundColor" small text color="primary"> Reset </v-btn>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <!-- Slides Per View -->
        <div class="mb-4">
          <label class="label-input">Slides Per View</label>
          <p class="text-caption">The viewport is based on the description’s width, not the window’s width.</p>
          <v-row>
            <v-col cols="12" md="4">
              <div>
                <v-text-field
                  v-model.number="fields.breakpoints.mobile.slidesPerView"
                  label="Mobile"
                  type="number"
                  :rules="[v => v > 0 || 'Slides Per View must be greater than 0']"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div>
                <v-text-field
                  v-model.number="fields.breakpoints.tablet.slidesPerView"
                  label="Tablet"
                  type="number"
                  :rules="[v => v > 0 || 'Slides Per View must be greater than 0']"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div>
                <v-text-field
                  v-model.number="fields.breakpoints.desktop.slidesPerView"
                  label="Desktop"
                  type="number"
                  :rules="[v => v > 0 || 'Slides Per View must be greater than 0']"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
        </div>

        <div class="wrap-reviews-form">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input" style="margin-bottom: 10px">Reviews ({{ fields['body-review'].length }})</label>
            <v-btn small text color="primary" @click="handleAddReview">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Review</span>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="6">
              <div style="margin-bottom: 20px">
                <div>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="background"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['card-text-color']"
                      @change="handleChangeCardTextColor"
                    />
                    <v-text-field v-model="fields['card-text-color']" label="Card Text Color" />
                    <v-btn @click="handleResetCardTextColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="6">
              <div style="margin-bottom: 20px">
                <div>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="background"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['card-background-color']"
                      @change="handleChangeCardBackground"
                    />
                    <v-text-field v-model="fields['card-background-color']" label="Card Background Color" />
                    <v-btn @click="handleResetCardBackground" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <div>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in fields['body-review']" :key="i">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <div class="reviewer-header">
                      <div class="reviewer-avatar">
                        <img :src="item.avatar" alt="" onerror="this.style.display='none'" />
                      </div>
                      <div class="reviewer-info">
                        <span class="reviewer-name">{{ item.name || '' }}</span>
                        <div @click.stop>
                          <v-rating
                            color="warning"
                            background-color="#c1c1c1"
                            empty-icon="mdi-star-outline"
                            full-icon="mdi-star"
                            half-icon="mdi-star-half-full"
                            hover
                            length="5"
                            size="20"
                            v-model="item.rating"
                          >
                          </v-rating>
                        </div>
                      </div>
                    </div>
                    <v-btn icon @click.stop="handleRemoveReview(i)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="wrap-review-form">
                    <v-text-field v-model="item.name" label="Reviewer Name" />
                    <div class="mb-5">
                      <label>Rating</label>
                      <v-rating
                        color="warning"
                        background-color="#c1c1c1"
                        empty-icon="mdi-star-outline"
                        full-icon="mdi-star"
                        half-icon="mdi-star-half-full"
                        hover
                        length="5"
                        size="35"
                        v-model="item.rating"
                      ></v-rating>
                    </div>
                    <div class="mb-5">
                      <label>Avatar Image</label>
                      <UploadImage
                        @callback="obj => handleUploadAvatar(obj, i)"
                        :image="{ imageSrc: item.avatar }"
                        :height="`150`"
                        :typeUpload="'image'"
                        @callbackDelete="handleRemoveAvatar(i)"
                      />
                    </div>
                    <div class="mb-5">
                      <label>Content</label>
                      <ckeditor :editor="editor" v-model="item['content']" :config="editorConfig" />
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
        <div class="mt-6">
          <label class="label-input mb-0">Padding </label>
          <v-row>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { cloneDeepObject } from '../common/utils';
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import productReviewsJson from '@/assets/json/product-reviews.json';

export default {
  name: 'ReviewGridSectionEditor02',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Review Grid Section 02',
        'title-review': '',
        'card-background-color': '#FFFFFF',
        'card-text-color': '#000000',
        'body-review': [],
        'background-color': '#FFF7F5',
        breakpoints: {
          mobile: {
            slidesPerView: 1,
          },
          tablet: {
            slidesPerView: 2,
          },
          desktop: {
            slidesPerView: 3,
          },
        },
        topPadding: true,
        bottomPadding: true,
      },
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updatedSection = {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtmlFromData.sectionReviewGrid02(this.sectionEditor.section.html, this.fields),
      };
      this.$emit('update:section', updatedSection);
      this.handleClosePopup();
    },
    handleAddReview() {
      const existingKeys = new Set(this.fields['body-review'].map(r => `${r.name}-${r.avatar}`));

      const candidates = productReviewsJson.slice(0, 10).filter(item => {
        const key = `${item.fullName || ''}-${item.avatar || ''}`;
        return !existingKeys.has(key);
      });

      if (candidates.length === 0) {
        this.$store.dispatch('setMessage', { color: 'warning', dialog: true, content: 'No more reviews to add!' });
        return;
      }

      const randomReview = candidates[Math.floor(Math.random() * candidates.length)];

      this.fields['body-review'].unshift({
        name: randomReview.fullName || ``,
        rating: 5,
        avatar: randomReview.avatar || '',
        content: 'Great product!',
      });
    },
    handleRemoveReview(index) {
      this.fields['body-review'].splice(index, 1);
    },
    handleUploadAvatar(obj, index) {
      if (obj && obj.imageSrc) {
        this.fields['body-review'][index].avatar = obj.imageSrc;
      }
    },
    handleRemoveAvatar(index) {
      this.fields['body-review'][index].avatar = '';
    },
    handleChangeBackgroundColor(event) {
      this.fields['background-color'] = event.target.value;
    },
    handleChangeCardTextColor(event) {
      this.fields['card-text-color'] = event.target.value;
    },
    handleChangeCardBackground(event) {
      this.fields['card-background-color'] = event.target.value;
    },
    handleResetBackgroundColor() {
      this.fields['background-color'] = '#FFF7F5';
    },
    handleResetCardTextColor() {
      this.fields['card-text-color'] = '#000000';
    },
    handleResetCardBackground() {
      this.fields['card-background-color'] = '#FFFFFF';
    },
  },
  mounted() {
    if (this.sectionEditor.sectionExtract) {
      this.fields = cloneDeepObject(this.sectionEditor.sectionExtract);
    }
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal.sectionExtract) {
          this.fields = cloneDeepObject(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .ck-editor__editable {
  min-height: 200px !important;
}
::v-deep .ck-editor__editable_inline {
  min-height: 200px !important;
}

.label-input {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
  display: block;
}

.wrap-review-form {
  padding: 16px 0;
}

.wrap-reviews-form {
  margin-top: 20px;
}

.header-modal,
.footer-modal {
  padding: 0 24px;
  border-bottom: 1px solid #e0e0e0;
}

.footer-modal {
  border-top: 1px solid #e0e0e0;
  border-bottom: none;
}

.d-flex {
  display: flex;
}

.align-center {
  align-items: center;
}

.gap-3 {
  gap: 12px;
}
.reviewer-header {
  display: flex;
  align-items: center;
  gap: 12px;

  .reviewer-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #e0e0e0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: relative;
      z-index: 2;
    }

    &::before {
      content: '';
      font-size: 20px;
      color: #999;
      position: absolute;
    }
  }

  .reviewer-info {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .reviewer-name {
    font-size: 16px;
    font-weight: 500;
  }
}
</style>
